import PropTypes from 'prop-types';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
export const ProductActivationPropsInterface = Object.assign({}, upgradeDataPropsInterface, {
  onSuccess: PropTypes.func.isRequired
});